import { graphql, HttpResponse } from 'msw'
import {
  type AccountRecoveryError,
  AccountRecoveryErrorType,
  type AccountRecoveryResponse,
  type AccountRecoveryResponseV2,
  AccountRecoveryStatus,
  type AuthenticateWebAuthnError,
  AuthenticateWebAuthnErrorType,
  type AuthenticateWebAuthnSuccess,
  LoginOtpVerificationErrorType,
  type LoginOtpVerificationOutput,
  type PingSessionOutput,
  type RegisterWebAuthnSuccess,
  type SignOutOutput,
  type StartWebAuthnAuthenticationSuccess,
  type StartWebAuthnRegistrationSuccess,
  type RemovePasskeySuccess,
  type RemovePasskeyError,
  RemovePasskeyErrorType,
  type AuthSignOutResponse,
  type AuthsvsPasskeysOutput,
  type RefreshTokenResponse,
  SessionType,
} from '../../models'
import { mockAuthReentry } from './re-entry.mock'

// startWebAuthnAuthentication
export const startWebAuthnAuthenticationMock: StartWebAuthnAuthenticationSuccess = {
  __typename: 'StartWebAuthnAuthenticationSuccess',
  publicKeyCredentialRequestOptions:
    '{"challenge":"SdSfvcdHNtsluMwmnKm9Z2o_oUNgfqvmMs6FIBr0KI8","rpId":"localhost","extensions":{}}',
}

export const startWebAuthnAuthenticationMockHandler = graphql.mutation('startWebAuthnAuthentication', () => {
  return HttpResponse.json({ data: { startWebAuthnAuthentication: startWebAuthnAuthenticationMock } })
})

// authenticateWebAuthn
export const authenticateWebAuthnMock: AuthenticateWebAuthnSuccess = {
  __typename: 'AuthenticateWebAuthnSuccess',
  customerId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
  isManualReviewApplicant: false,
}

export const authenticateWebAuthnErrorMock: AuthenticateWebAuthnError = {
  __typename: 'AuthenticateWebAuthnError',
  errorType: AuthenticateWebAuthnErrorType.OTP_VERIFICATION_REQUIRED,
}

export const authenticateWebAuthnMockHandler = graphql.mutation('authenticateWebAuthn', () => {
  return HttpResponse.json({ data: { authenticateWebAuthn: authenticateWebAuthnMock } })
})

export const authsvsAuthenticateWebAuthnMockHandler = graphql.mutation('authsvsAuthenticateWebAuthn', () => {
  return HttpResponse.json({ data: { authsvsAuthenticateWebAuthn: authsvsAuthenticateWebAuthnMock } })
})

// startWebAuthnRegistration
export const startWebAuthnRegistrationMock: StartWebAuthnRegistrationSuccess = {
  __typename: 'StartWebAuthnRegistrationSuccess',
  publicKeyCredentialCreationOptions:
    '{"challenge":"SdSfvcdHNtsluMwmnKm9Z2o_oUNgfqvmMs6FIBr0KI8","rpId":"localhost","extensions":{}}',
}

export const startWebAuthnRegistrationMockHandler = graphql.mutation('startWebAuthnRegistration', () => {
  return HttpResponse.json({ data: { startWebAuthnRegistration: startWebAuthnRegistrationMock } })
})

// registerWebAuthn
export const registerWebAuthnMock: RegisterWebAuthnSuccess = {
  __typename: 'RegisterWebAuthnSuccess',
  userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
}

export const registerWebAuthnMockHandler = graphql.mutation('registerWebAuthn', () => {
  return HttpResponse.json({ data: { registerWebAuthn: registerWebAuthnMock } })
})

// pingSession
export const pingSessionMock: PingSessionOutput = {
  __typename: 'AuthenticatedSession',
  userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
}

export const pingSessionMockHandler = graphql.mutation('pingSession', () => {
  return HttpResponse.json({ data: { pingSession: pingSessionMock } })
})

// signOut
export const signOutMock: SignOutOutput = {
  isSuccessful: true,
}

export const signOutMockHandler = graphql.mutation('signOut', () => {
  return HttpResponse.json({ data: { signOut: signOutMock } })
})

export const accountRecoveryResponseMock: AccountRecoveryResponse = {
  __typename: 'AccountRecoveryResponse',
  status: AccountRecoveryStatus.VERIFICATION_CONFIRMED,
}

export const accountRecoveryResponseV2Mock: AccountRecoveryResponseV2 = {
  __typename: 'AccountRecoveryResponseV2',
  status: AccountRecoveryStatus.VERIFICATION_CONFIRMED,
}

export const accountRecoveryErrorMock: AccountRecoveryError = {
  __typename: 'AccountRecoveryError',
  errorType: AccountRecoveryErrorType.EXPIRED,
}

export const mockAccountRecoverySuccess = graphql.mutation('accountRecovery', () => {
  return HttpResponse.json({ data: { accountRecovery: accountRecoveryResponseMock } })
})

export const mockAccountRecoveryError = graphql.mutation('accountRecovery', () => {
  return HttpResponse.json({ data: { accountRecovery: accountRecoveryErrorMock } })
})

export const mockAccountRecovery = mockAccountRecoverySuccess

export const mockAccountRecoveryV2Success = graphql.mutation('accountRecoveryV2', () => {
  return HttpResponse.json({ data: { accountRecoveryV2: accountRecoveryResponseV2Mock } })
})

export const mockAccountRecoveryV2Error = graphql.mutation('accountRecoveryV2', () => {
  return HttpResponse.json({ data: { accountRecoveryV2: accountRecoveryErrorMock } })
})

export const mockAccountRecoveryV2 = mockAccountRecoveryV2Success

// Login OTP Verification

export const loginOtpVerificationMock: LoginOtpVerificationOutput = {
  __typename: 'LoginOtpVerification',
  userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
  isManualReviewApplicant: false,
}

export const loginOtpVerificationErrorMock: LoginOtpVerificationOutput = {
  __typename: 'LoginOtpVerificationError',
  errorType: LoginOtpVerificationErrorType.OTP_VERIFICATION_FAILED,
}

export const resendOtpMock: LoginOtpVerificationOutput = {
  __typename: 'ResendOtp',
  isSuccessful: true,
}

export const loginOtpVerificationMockHandler = graphql.mutation('loginOtpVerification', () => {
  return HttpResponse.json({ data: { loginOtpVerification: loginOtpVerificationMock } })
})

// Auth service WebAuthn methods
export const authsvsStartWebAuthnRegistrationMock: StartWebAuthnRegistrationSuccess = {
  __typename: 'StartWebAuthnRegistrationSuccess',
  publicKeyCredentialCreationOptions:
    '{"challenge":"SdSfvcdHNtsluMwmnKm9Z2o_oUNgfqvmMs6FIBr0KI8","rp":{"name":"Evergreen","id":"localhost"},"user":{"id":"dXNlci03ODdjZDU3Mi0xYjc2LTQyNDEtOTI3NC00ZGM4MjllY2Y2Nzg","name":"user@example.com","displayName":"User"},"pubKeyCredParams":[{"alg":-7,"type":"public-key"}],"timeout":60000,"attestation":"none","extensions":{}}',
}

export const authsvsStartWebAuthnRegistrationMockHandler = graphql.mutation('authsvsStartWebAuthnRegistration', () => {
  return HttpResponse.json({ data: { authsvsStartWebAuthnRegistration: authsvsStartWebAuthnRegistrationMock } })
})

export const authsvsRegisterWebAuthnMock: RegisterWebAuthnSuccess = {
  __typename: 'RegisterWebAuthnSuccess',
  userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
}

export const authsvsRegisterWebAuthnMockHandler = graphql.mutation('authsvsRegisterWebAuthn', () => {
  return HttpResponse.json({ data: { authsvsRegisterWebAuthn: authsvsRegisterWebAuthnMock } })
})

export const authsvsStartWebAuthnAuthenticationMock: StartWebAuthnAuthenticationSuccess = {
  __typename: 'StartWebAuthnAuthenticationSuccess',
  publicKeyCredentialRequestOptions:
    '{"challenge":"SdSfvcdHNtsluMwmnKm9Z2o_oUNgfqvmMs6FIBr0KI8","rpId":"localhost","allowCredentials":[{"type":"public-key","id":"credentialId123"}],"timeout":60000,"extensions":{}}',
}

export const authsvsStartWebAuthnAuthenticationMockHandler = graphql.mutation(
  'authsvsStartWebAuthnAuthentication',
  () => {
    return HttpResponse.json({ data: { authsvsStartWebAuthnAuthentication: authsvsStartWebAuthnAuthenticationMock } })
  },
)

export const authsvsAuthenticateWebAuthnMock: AuthenticateWebAuthnSuccess = {
  __typename: 'AuthenticateWebAuthnSuccess',
  customerId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
  isManualReviewApplicant: false,
}

// authsvsRemovePasskey
export const authsvsRemovePasskeyMock: RemovePasskeySuccess = {
  __typename: 'RemovePasskeySuccess',
  success: true,
}

export const authsvsRemovePasskeyErrorMock: RemovePasskeyError = {
  __typename: 'RemovePasskeyError',
  errorType: RemovePasskeyErrorType.PASSKEY_NOT_FOUND,
}

export const authsvsRemovePasskeyMockHandler = graphql.mutation('authsvsRemovePasskey', () => {
  return HttpResponse.json({ data: { authsvsRemovePasskey: authsvsRemovePasskeyMock } })
})

// authsvsSignOut
export const authsvsSignOutMock: AuthSignOutResponse = {
  success: true,
  message: 'Successfully signed out',
}

export const authsvsSignOutMockHandler = graphql.mutation('authsvsSignOut', () => {
  return HttpResponse.json({ data: { authsvsSignOut: authsvsSignOutMock } })
})

// authsvsGetAllPasskeys
export const authsvsGetAllPasskeysMock: AuthsvsPasskeysOutput[] = [
  {
    id: 'passkey-1',
    userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
    credentialId: 'credential-id-123',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
    devicePlatform: 'iOS',
    browserName: 'Safari',
  },
  {
    id: 'passkey-2',
    userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
    credentialId: 'credential-id-456',
    createdAt: '2024-01-02T00:00:00Z',
    updatedAt: '2024-01-02T00:00:00Z',
    devicePlatform: 'Android',
    browserName: 'Chrome',
  },
]

export const authsvsGetAllPasskeysMockHandler = graphql.mutation('authsvsGetAllPasskeys', () => {
  return HttpResponse.json({ data: { authsvsGetAllPasskeys: authsvsGetAllPasskeysMock } })
})

// authsvsRefreshToken
export const authsvsRefreshTokenMock: RefreshTokenResponse = {
  __typename: 'RefreshTokenResponse',
  accessToken: `mock-access-token-${Date.now().toString()}`,
  sessionType: SessionType.AUTHENTICATED,
  expiresAt: new Date(Date.now() + 3600000).toISOString(), // 1 hour from now
  userId: 'user-787cd572-1b76-4241-9274-4dc829ecf678',
}
export const authsvsRefreshTokenUnauthMock: RefreshTokenResponse = {
  __typename: 'RefreshTokenResponse',
  accessToken: `mock-access-token-${Date.now().toString()}`,
  sessionType: SessionType.ANONYMOUS,
  expiresAt: new Date(Date.now() + 3600000).toISOString(), // 1 hour from now
  userId: null,
}

/**
 * Returns the appropriate refresh token response based on environment variable.
 * Use VITE_MOCK_AUTH_MODE environment variable to control mock authentication state:
 * - VITE_MOCK_AUTH_MODE=authenticated - Returns authenticated user (for dashboard, transfers, etc.)
 * - VITE_MOCK_AUTH_MODE=anonymous - Returns unauthenticated user (for sign-in, enrollment)
 *
 * Note: Uses __VITE_MOCK_AUTH_MODE__ global variable defined by Vite at build time for browser code.
 * Falls back to process.env for Jest (Node.js) tests.
 *
 * E2E Usage with Cucumber tags:
 * @mock:authenticated - Set VITE_MOCK_AUTH_MODE=authenticated for that scenario
 * @mock:anonymous - Set VITE_MOCK_AUTH_MODE=anonymous for that scenario
 */
const getRefreshTokenResponse = (): RefreshTokenResponse => {
  // Check global variable (Vite) first, then Node.js environment (Jest)
  const mockAuthMode =
    (typeof __VITE_MOCK_AUTH_MODE__ !== 'undefined' && __VITE_MOCK_AUTH_MODE__) ||
    (typeof process !== 'undefined' && process.env?.MOCK_AUTH_MODE) ||
    'authenticated'

  return mockAuthMode === 'authenticated' ? authsvsRefreshTokenMock : authsvsRefreshTokenUnauthMock
}

export const authsvsRefreshTokenMockHandler = graphql.mutation('authsvsRefreshToken', () => {
  return HttpResponse.json({ data: { authsvsRefreshToken: getRefreshTokenResponse() } })
})

export const mockAuthn = [
  startWebAuthnAuthenticationMockHandler,
  authsvsStartWebAuthnAuthenticationMockHandler,
  authenticateWebAuthnMockHandler,
  authsvsAuthenticateWebAuthnMockHandler,
  startWebAuthnRegistrationMockHandler,
  authsvsStartWebAuthnRegistrationMockHandler,
  registerWebAuthnMockHandler,
  authsvsRegisterWebAuthnMockHandler,
  pingSessionMockHandler,
  signOutMockHandler,
  mockAccountRecovery,
  mockAccountRecoveryV2,
  loginOtpVerificationMockHandler,
  // Auth service WebAuthn methods
  authsvsStartWebAuthnRegistrationMockHandler,
  authsvsRegisterWebAuthnMockHandler,
  authsvsStartWebAuthnAuthenticationMockHandler,
  authsvsAuthenticateWebAuthnMockHandler,
  authsvsRemovePasskeyMockHandler,
  // Auth re-entry methods
  ...mockAuthReentry,
  authsvsSignOutMockHandler,
  authsvsGetAllPasskeysMockHandler,
  authsvsRefreshTokenMockHandler,
]
